module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/logo_jg.png"
    }
  }), _vm._v(" "), _c('hello')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-407d96aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/App.vue
// module id = 254
// module chunks = 2